import { carouselItems } from "@/mocks/home";

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">精选内容专题 — 一站式发现好片</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-300/50 transition-all duration-200"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded bg-accent-500 text-white">
                    {item.tag}
                  </span>
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded bg-black/50 text-white">
                    {item.badge}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}